import { RoutingPaths } from 'app/routes/routes'

export const FilterBarItems = [
  {
    title: 'sort',
    link: RoutingPaths.kyrgyzstan.sort.path(),
  },
  {
    title: 'filters',
    link: RoutingPaths.kyrgyzstan.filters.path(),
  },
]
